import React from 'react';
import ShowOnlyPendingRequestsCheckbox from '../../../../../views/pages/manage/unAssigned/studentFinanceApproval/paymodeApproval/ShowOnlyPendingRequestsCheckbox';
import AMultiFieldSearchInput from '../../../../../components/AMultiFieldSearchInput/AMultiFieldSearchInput';
// import { searchInputOptions, statusFilterOptions } from '../components/searchStudent/studentTransfersListing/utils';
// import { searchInputOptions } from './constant';
// import { getFilterFormFields } from './constant';
import FilterForm from './FilterForm';
import AButton from '../../../../../views/pages/manage/common/form-fields-mui/AButton';
import APopover from '../../../../../views/pages/manage/common/a-popover';
import {cashInitialFilterForm } from '../../shared/constant';
import { approvalConfig } from '../../shared/config';
// import { EMPTY_FILTER_FORM, getFilterFormFields } from './utils';

const Filters = ({
    dropdowns,
    getApprovalRequests,
    loading,
    globalFilter,
    setGlobalFilter,
    searchInputOptions = {},
    type
}) => {


    const searchHandler = (filters = {}) => {
        getApprovalRequests({
            filters: { ...globalFilter, ...filters },
            pageNo: 0
        })
    }



    return (
        <div className='d-flex align-items-center' style={{ gap: '0.75rem' }}>
            <ShowOnlyPendingRequestsCheckbox
                checked={(globalFilter?.status||[]).some(item=>item?.value == 'PENDING')}
                showOnlyPendingRequestsHandler={checked => {
                    searchHandler({
                        status :checked? [{label:'Pending',value:'PENDING'}]  :[]
                    })
                }}
            />
            <div style={{marginBottom: '1rem'}}>
            <AMultiFieldSearchInput
                options={searchInputOptions}
                isLoading={loading}
                searchHandler={(keyName, value) => searchHandler({ [keyName]: value||null })}
                crossHandler={(keyName, value) => searchHandler({ [keyName]: value || null})}
            />
            </div>

            <APopover
                buttonComponent={(openPopover, styles) => (
                     <div style={{marginBottom: '1rem'}}>
                    <AButton
                        className="tiny-semi-bold color-dark"
                        onClick={openPopover}
                        size="xs"
                        updatedStyle={{
                            minWidth: "61px",
                            ...(globalFilter?.appliedFilterCount > 0
                                ? {
                                    border: "1px solid #00B0F5",
                                    color: "#00B0F5",
                                }
                                : styles),
                        }}
                    >
                        Filters {globalFilter?.appliedFilterCount || ''}
                        {/* {filterCount > 0 ? `(${filterCount})` : ""} */}
                    </AButton>
                    </div>
                )}
                menuComponent={(closePopup) =>
                    <FilterForm
                        closePopup={closePopup}
                        dropdownData={dropdowns}
                        globalFilter={globalFilter}
                        setGlobalFilter={setGlobalFilter}
                        searchHandler={searchHandler}
                        getFilterFormFields={approvalConfig?.[type]?.filters}
                        initialForm={approvalConfig?.[type]?.initialFilterForm}
                    />
                }
            />

        </div>
    );
}

export default Filters;